import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Link,
  Card,
  CardHeader,
  Divider,
  CardContent,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
//import CloseIcon from '@material-ui/icons/Close';
import firebase, {
  functionBaseUrl,
  axiosWithToken,
} from "../../common/firebase";
import Swal from "sweetalert2";
import "./Dashboard.css";
import { StripeSubscription } from "../../components/stripeSubscription";
import {
  defaultHeightToDefaultHipWidth,
  defaultHeightToHipWidth,
  femaleHeightToDefaultHipWidth,
  femaleHeightToHipWidth,
  //femaleHipWith,
  heightValues,
  maleHeightToDefaultHipWidth,
  maleHeightToHipWidth,
  //maleHipWith,
} from "../students/misc/hipWidthTable";
import moment from "moment";
import { useHistory } from "react-router-dom";

function formatHeight(value = "") {
  let tempHeight = value;
  if (tempHeight && tempHeight.includes(".")) {
    tempHeight = tempHeight.replace(".", "'");
  }
  if (tempHeight && tempHeight.includes("`")) {
    tempHeight = tempHeight.replace("`", "'");
  }
  if (tempHeight && tempHeight.includes("``")) {
    tempHeight = tempHeight.replace("``", '"');
  }
  if (tempHeight && !tempHeight.includes('"')) {
    tempHeight = `${tempHeight}"`;
  }
  return tempHeight;
}

function computeHipWidth(height, gender) {
  let result = 7.1;
  if (height !== "" && gender !== "") {
    switch (gender) {
      case "MALE":
        result = maleHeightToDefaultHipWidth[height];
        break;
      case "FEMALE":
        result = femaleHeightToDefaultHipWidth[height];
        break;
      default:
        result = defaultHeightToDefaultHipWidth[height];
        break;
    }
  }
  return result;
}

const NewAccountCheck = (props) => {
  const {
    invitesReceived: invitesReceivedProp = [],
    subscriptionType,
    userData = {},
    subData,
    uid,
    email,
    fullName,
    onClose,
    open,
  } = props;

  const history = useHistory();

  const [dob, setDob] = useState(userData.dob || "");
  const [height, setHeight] = useState(formatHeight(userData.height || ""));
  const [gender, setGender] = useState(userData.gender || "");
  const [dominantHand, setDominantHand] = useState(userData.dominantHand || "");
  const [hipWidth, setHipWidth] = useState(userData.hipWidth || "");
  const [currentStep, setCurrentStep] = useState("agreements");
  const [tosAgree, setTosAgree] = useState(false);
  const [consentAgree, setConsentAgree] = useState(true);
  const [invitesReceived, setInvitesReceived] = useState(
    invitesReceivedProp || []
  );
  const [weeklyPractices, setWeeklyPractices] = useState(
    userData.weeklyPractices || 0
  );
  const [averageScore, setAverageScore] = useState(userData.averageScore || 0);

  useEffect(() => {
    if (userData.dob !== "" && userData.userConsent !== "") {
      if (
        userData.subscriptionType?.includes("free") ||
        userData.subscriptionType?.includes("student_lite")
      ) {
        setCurrentStep("invite");
      } else {
        setCurrentStep("additionalFields");
      }
    }
  }, [userData.dob, userData.subscriptionType, userData.userConsent]);

  useEffect(() => {
    if (currentStep === "creditCard") {
      setCurrentStep("invite");
    }
  }, [currentStep]);

  useEffect(() => {
    setInvitesReceived(invitesReceivedProp || []);
  }, [invitesReceivedProp]);

  useEffect(() => {
    if (height !== "" && gender !== "") {
      setHipWidth(computeHipWidth(height, gender));
    }
  }, [gender, height]);

  const handleChange = (prop) => (event) => {
    const { value } = event.target;
    switch (prop) {
      case "dob":
        setDob(value);
        break;
      case "height":
        setHeight(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "dominantHand":
        setDominantHand(value);
        break;
      case "hipWidth":
        setHipWidth(value);
        break;
      case "weeklyPractices":
        setWeeklyPractices(value);
        break;
      case "averageScore":
        setAverageScore(value);
        break;
      default:
        break;
    }
  };

  const handleTOSAgree = () => {
    setTosAgree((prev) => !prev);
  };

  const handleConsentAgree = () => {
    setConsentAgree((prev) => !prev);
  };

  const handleBack = () => {
    if (currentStep === "creditCard") {
      setCurrentStep("agreements");
    }
    if (currentStep === "invite") {
      setCurrentStep("agreements");
    }
    if (currentStep === "additionalFields") {
      setCurrentStep("invite");
    }
  };

  const dobFormat = (dobValue) => {
    const [year, month, day] = dobValue.split("-");
    return month + "/" + day + "/" + year;
  };

  const validEmail = (emailValue) => {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(emailValue);
  };

  const requesterRole = (invite) => {
    let role = "";
    if (invite && invite.role) {
      role = invite.role;
    }
    return role;
  };

  const dateDisplay = (date) => {
    return moment(String(date), "x").format("MM/DD/YYYY");
  };

  const inviteValidity = (invite) => {
    let date = "";
    if (invite && invite.expiredIn) {
      date = dateDisplay(invite.expiredIn);
    }
    return date;
  };

  const approveRequest = (requestId) => (event) => {
    Swal.fire({
      title: '<p style="font-size:70%;">Accept Invite</p>',
      html: "<p>Are you sure you want to accept this invite?</p>",
      customClass: {
        container: "my-swal",
      },
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonColor: "red",
    })
      .then((result) => {
        if (result.isConfirmed) {
          axiosWithToken(functionBaseUrl + "/api/approveInvite/" + requestId, {
            method: "POST",
          })
            .then(() => {
              setInvitesReceived((prev) =>
                prev.filter((item) => item.id !== String(requestId))
              );
              Swal.fire({
                title:
                  '<p style="font-size:70%;">Invite Accepted Successfully!</p>',
                icon: "success",
                customClass: { container: "my-swal" },
                timer: 2000,
              });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                text: err,
                customClass: { container: "my-swal" },
              });
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const rejectRequest = (requestId) => (event) => {
    Swal.fire({
      title: '<p style="font-size:70%;">Reject Invite</p>',
      html: "<p>Are you sure you want to reject this invite?</p>",
      customClass: {
        container: "my-swal",
      },
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonColor: "red",
      allowOutsideClick: false,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          await axiosWithToken(
            functionBaseUrl + "/api/rejectInvite/" + requestId,
            {
              method: "post",
            }
          )
            .then(() => {
              setInvitesReceived((prev) =>
                prev.filter((item) => item.id !== String(requestId))
              );
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                text: err,
                customClass: { container: "my-swal" },
              });
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getButton = () => {
    if (
      currentStep === "agreements" ||
      currentStep === "creditCard" ||
      currentStep === "invite"
    ) {
      return "Next";
    }
    if (currentStep === "additionalFields") {
      return "Submit";
    }
    return "Next";
  };

  const pageTitle = () => {
    if (currentStep === "agreements") {
      return "Agreements";
    }
    if (currentStep === "creditCard") {
      return "Enter Credit Card Details";
    }
    if (currentStep === "invite") {
      return "Pending Invites";
    }
    if (currentStep === "additionalFields") {
      return "Enter User Details";
    }
    return "User Details";
  };

  const getDisabled = () => {
    if (currentStep === "agreements") {
      return !tosAgree || dob.length < 10;
    }
    if (currentStep === "creditCard") {
      return true;
    }
    if (currentStep === "invite") {
      return !(invitesReceived.length === 0);
    }
    if (currentStep === "additionalFields") {
      return height === "" || gender === "" || dominantHand === "";
    }
    return false;
  };

  const getAmount = () => {
    if (subData && subData.amount) {
      return subData.amount;
    }
  };

  const createSubscription = async (data) => {
    try {
      await axiosWithToken(functionBaseUrl + "/api/subscription", {
        method: "POST",
        data: {
          userId: uid,
          plan: subscriptionType,
          planDescription: "",
          planType: subscriptionType?.includes("monthly")
            ? "Monthly"
            : "Annually",
          transactionId: data.id,
          payload: "",
          packageId: "",
          orderId: "",
          amount: (data.amount / 100).toFixed(2),
          startDate: subData.startDate,
          endDate: subData.endDate,
          lastUpdated: String(Date.now()),
          autoRenewal: true,
          platform: "Stripe",
          productId: subscriptionType,
          promoCode: "",
        },
      });
      await Swal.fire({
        title: `<p style="font-size:70%;">Thank you for subscribing!</p>`,
        showConfirmButton: false,
        icon: "success",
        customClass: {
          container: "my-swal",
        },
        timer: 2000,
        showCloseButton: true,
        allowOutsideClick: true,
      }).then(() => {
        setCurrentStep("invite");
      });
    } catch (err) {
      console.log(err);
      Swal.fire({
        title:
          '<p style="font-size:70%;">There was an error processing your subscription, please try again.</p>',
        icon: "error",
        customClass: {
          container: "my-swal",
        },
      });
    }
  };

  const getDate = () => {
    return moment(String(subData.endDate), "x").format("MM/DD/YYYY");
  };

  const getPlan = (plan) => {
    if (plan?.includes("student_lite")) {
      return "3D Player";
    } else if (plan?.includes("pro_lite")) {
      return "3D Pro";
    } else if (plan?.includes("pro_premium")) {
      return "3D Pro";
    } else if (plan?.includes("enterprise")) {
      return "Enterprise Master";
    } else {
      return "Free";
    }
  };

  const handleSubmit = async () => {
    if (currentStep === "agreements") {
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      const date = new Date(
        new Date().setFullYear(new Date().getFullYear() - 13)
      )
        .toLocaleDateString("en-ZA", options)
        .replaceAll("/", "-");
      if (Date.parse(dob) > Date.parse(date)) {
        await Swal.fire({
          title:
            '<p style="font-size:70%;">Sorry, you are not eligible for a Sportsbox.ai account at this time.</p>',
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          customClass: {
            container: "my-swal",
          },
        }).then(async () => {
          try {
            await firebase.auth().signOut();
            console.log("logged out" + firebase.auth().currentUser);
          } catch (error) {
            console.log(error);
          }
        });
        return false;
      }

      if (
        !subscriptionType?.includes("student_lite") ||
        ("transactionId" in subData && subData.transactionId !== "")
      ) {
        setCurrentStep("invite");
      } else {
        setCurrentStep("invite");
      }
      return;
    }

    if (currentStep === "invite") {
      if (userData.dob === "") {
        setCurrentStep("additionalFields");
      } else {
        try {
          await axiosWithToken(functionBaseUrl + "/api/users/" + uid, {
            method: "patch",
            data: {
              userInfo: {
                dob: dob?.includes("/") ? dob : dobFormat(dob),
                gender,
                height,
                hipSize: hipWidth,
                dominantHand,
                weeklyPractices,
                averageScore,
                userConsent: consentAgree,
              },
            },
          });
          onClose();
          const bufferSnap = await firebase
            .firestore()
            .collection("incompleteUsersBuffer")
            .where("userId", "==", uid)
            .get();
          bufferSnap.forEach(async function (doc) {
            await firebase
              .firestore()
              .collection("incompleteUsersBuffer")
              .doc(doc.id)
              .delete();
          });
          if (window.location.href.includes("mobileClient")) {
            Swal.fire({
              title: `<p style="font-size:70%;">Your changes have been saved!</p>`,
              showConfirmButton: false,
              icon: "success",
              showCloseButton: true,
              allowOutsideClick: true,
              customClass: {
                container: "my-swal",
              },
            }).then(() => {
              window.location = "sportsboxclient://update_password";
            });
          } else {
            Swal.fire({
              title: `<p style="font-size:70%;">Your changes have been saved!<br /><br /> Please click on these links to download the app: </p>
                <a href='https://apps.apple.com/us/app/sportsbox-3dgolf/id1578921026'><img width='40%' alt='Download on the App Store' src='https://miro.medium.com/max/600/1*xqT83bMEz92IBYxS9UQNow.png'></a>
                <a href='https://play.google.com/store/apps/details?id=com.sportsbox.golfai'><img width='40%' alt='Get it on Google Play' src='https://miro.medium.com/max/600/1*nZu0dsnlCQltPT1QMCHFAA.png'/></a>`,
              showConfirmButton: false,
              icon: "success",
              showCloseButton: true,
              allowOutsideClick: true,
              customClass: {
                container: "my-swal",
              },
            }).then(() => {
              history.push("/account");
            });
          }
        } catch (err) {
          alert("There was an error updating your info");
          console.log(err);
        }
      }
      return;
    }

    if (currentStep === "additionalFields") {
      try {
        await axiosWithToken(functionBaseUrl + "/api/users/" + uid, {
          method: "patch",
          data: {
            userInfo: {
              dob: dob?.includes("/") ? dob : dobFormat(dob),
              gender,
              height,
              hipSize: hipWidth,
              dominantHand,
              weeklyPractices,
              averageScore,
              userConsent: consentAgree,
            },
          },
        });
        onClose();
        const bufferSnap = await firebase
          .firestore()
          .collection("incompleteUsersBuffer")
          .where("userId", "==", uid)
          .get();
        bufferSnap.forEach(async function (doc) {
          await firebase
            .firestore()
            .collection("incompleteUsersBuffer")
            .doc(doc.id)
            .delete();
        });
        if (window.location.href.includes("mobileClient")) {
          Swal.fire({
            title: `<p style="font-size:70%;">Your changes have been saved!</p>`,
            showConfirmButton: false,
            icon: "success",
            showCloseButton: true,
            allowOutsideClick: true,
            customClass: {
              container: "my-swal",
            },
          }).then(() => {
            window.location = "sportsboxclient://update_password";
          });
        } else {
          Swal.fire({
            title: `<p style="font-size:70%;">Your changes have been saved!<br /><br /> Please click on these links to download the app: </p>
              <a href='https://apps.apple.com/us/app/sportsbox-3dgolf/id1578921026'><img width='40%' alt='Download on the App Store' src='https://miro.medium.com/max/600/1*xqT83bMEz92IBYxS9UQNow.png'></a>
              <a href='https://play.google.com/store/apps/details?id=com.sportsbox.golfai'><img width='40%' alt='Get it on Google Play' src='https://miro.medium.com/max/600/1*nZu0dsnlCQltPT1QMCHFAA.png'/></a>`,
            showConfirmButton: false,
            icon: "success",
            showCloseButton: true,
            allowOutsideClick: true,
            customClass: {
              container: "my-swal",
            },
          }).then(() => {
            history.push("/account");
          });
        }
      } catch (err) {
        alert("There was an error updating your info");
        console.log(err);
      }
    }
  };

  const handleSignOut = async () => {
    try {
      await firebase.auth().signOut();
      history.push("/sign-in");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Dialog
        fullWidth
        open={open}
        //onClose={onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id={"form-dialog-title"}>
          <div>
            <Typography variant="h5" color="secondary">
              User Details
            </Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container component="main" maxWidth="xs">
            <Grid item sm={12} style={{ marginBottom: "10px" }}>
              <Typography variant="h5" color="primary">
                {pageTitle()}
              </Typography>
            </Grid>
            {currentStep === "agreements" && (
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    id="date"
                    label="Date of Birth"
                    onChange={handleChange("dob")}
                    type="date"
                    value={dob}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        value={tosAgree}
                        onChange={handleTOSAgree}
                        checked={tosAgree}
                      />
                    }
                    label={
                      <div>
                        <span>I have read and agree to Sportsbox's </span>
                        <Link
                          onClick={async (e) => {
                            e.preventDefault();
                            window.open(
                              "/terms-of-service?newAccount",
                              "_blank"
                            );
                          }}
                        >
                          Terms of Service &
                        </Link>
                        <Link
                          onClick={async (e) => {
                            e.preventDefault();
                            window.open("/privacy?newAccount", "_blank");
                          }}
                        >
                          {" "}
                          Privacy Policy.
                        </Link>
                      </div>
                    }
                  />
                </Grid>
              </Grid>
            )}
            {currentStep === "creditCard" && (
              <Grid container spacing={1}>
                <Typography
                  variant="h6"
                  style={{ color: "black", marginBottom: "10px" }}
                >
                  You have been gifted {subData?.coachDetails?.period}{" "}
                  {subscriptionType?.includes("monthly")
                    ? "month(s)"
                    : "year(s)"}{" "}
                  of 3D Player by your coach. At the end of your current
                  subscription, your plan will auto-renew and your credit card
                  will be charged. Please enter your credit card details below:
                </Typography>
                <Grid item xs={12}>
                  {subData && subData.endDate ? (
                    <div style={{ margin: "0 auto", marginTop: "5%" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <StripeSubscription
                            email={email}
                            productId={subscriptionType}
                            handleResult={createSubscription}
                            trialEnd={subData.endDate}
                            hideCoupon={true}
                            amount={subData.amount}
                            fullName={fullName}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  ) : (
                    <div>
                      <img width="4%" src="images/loading.gif" alt="Loading" />
                    </div>
                  )}
                </Grid>
              </Grid>
            )}
            {currentStep === "invite" && (
              <Grid container spacing={1}>
                {invitesReceived.length === 0
                  ? "There are no invites"
                  : invitesReceived.map((invite) => (
                      <Card style={{ minWidth: "50%" }} key={invite.id}>
                        <CardHeader
                          title={
                            invite.sender.firstName +
                            " " +
                            invite.sender.lastName +
                            " (" +
                            invite.sender.email +
                            ")"
                          }
                          titleTypographyProps={{
                            variant: "h5",
                            color: "primary",
                          }}
                        />
                        <Typography
                          component="h6"
                          variant="h6"
                          justify="center"
                          style={{
                            marginLeft: "15px",
                            marginRight: "15px",
                            marginTop: "-10px",
                          }}
                        >
                          <i>
                            {"is inviting your for the role of " +
                              requesterRole(invite)}
                          </i>
                        </Typography>
                        <Typography
                          component="h6"
                          variant="h6"
                          justify="center"
                          style={{
                            marginLeft: "15px",
                            marginRight: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          <b>Valid Till: </b>
                          {" " + inviteValidity(invite)}
                        </Typography>
                        <Divider />
                        <CardContent>
                          <Grid container justify="space-between">
                            <Button
                              style={{ margin: "0 auto", display: "flex" }}
                              variant="contained"
                              color="primary"
                              justify="center"
                              onClick={approveRequest(invite.id)}
                            >
                              Accept
                            </Button>

                            <Button
                              style={{ margin: "0 auto", display: "flex" }}
                              variant="contained"
                              color="secondary"
                              justify="center"
                              onClick={rejectRequest(invite.id)}
                            >
                              Reject
                            </Button>
                          </Grid>
                        </CardContent>
                      </Card>
                    ))}
              </Grid>
            )}
            {currentStep === "additionalFields" && (
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <FormControl variant="outlined" fullWidth margin="dense">
                    <InputLabel id="height-label">Height*</InputLabel>
                    <Select
                      fullWidth
                      id="height"
                      label="Height"
                      labelId="height-label"
                      name="height"
                      onChange={handleChange("height")}
                      value={height}
                      variant="outlined"
                    >
                      {heightValues.map((el) => (
                        <MenuItem key={el} value={el}>
                          {el}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="outlined" fullWidth margin="dense">
                    <InputLabel id="gender-select">Gender*</InputLabel>
                    <Select
                      fullWidth
                      id="gender"
                      label="Gender*"
                      labelId="gender-select"
                      name="gender"
                      value={gender?.toUpperCase()}
                      onChange={handleChange("gender")}
                    >
                      <MenuItem value={"FEMALE"}>Female</MenuItem>
                      <MenuItem value={"MALE"}>Male</MenuItem>
                      <MenuItem value={"PREFER NOT TO ANSWER"}>
                        Prefer not to answer
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/*gender !== "" && height !== "" && (
                  <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth margin="dense">
                      <InputLabel fullWidth id="hipWidth-label">
                        Hip Width*
                      </InputLabel>
                      <Select
                        fullWidth
                        id="hipWidth"
                        label="HipWidth"
                        labelId="hipWidth-label"
                        name="hipWidth"
                        onChange={handleChange("hipWidth")}
                        value={hipWidth}
                        variant="outlined"
                      >
                        {(() => {
                          if (height) {
                            switch (gender) {
                              case "MALE":
                                return maleHeightToHipWidth[height]?.map(
                                  (el) => (
                                    <MenuItem key={el} value={el}>
                                      {el}
                                    </MenuItem>
                                  )
                                );
                              case "FEMALE":
                                return femaleHeightToHipWidth[height]?.map(
                                  (el) => (
                                    <MenuItem key={el} value={el}>
                                      {el}
                                    </MenuItem>
                                  )
                                );
                              case "PREFER NOT TO ANSWER":
                                return defaultHeightToHipWidth[height]?.map(
                                  (el) => (
                                    <MenuItem key={el} value={el}>
                                      {el}
                                    </MenuItem>
                                  )
                                );
                              default:
                                break;
                            }
                          }
                        })()}
                      </Select>
                    </FormControl>
                  </Grid>
                )*/}
                <Grid item xs={6}>
                  <FormControl variant="outlined" fullWidth margin="dense">
                    <InputLabel fullWidth id="domHand-select">
                      Dominant Hand*
                    </InputLabel>
                    <Select
                      fullWidth
                      id="domHand"
                      label="Dominant Hand*"
                      labelId="domHand-select"
                      name="domHand"
                      value={dominantHand}
                      onChange={handleChange("dominantHand")}
                    >
                      <MenuItem value={"Left"}>Left</MenuItem>
                      <MenuItem value={"Right"}>Right</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Weekly Practices"
                    name="weeklyPractices"
                    margin="dense"
                    onChange={handleChange("weeklyPractices")}
                    value={weeklyPractices}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">days</InputAdornment>
                      ),
                      inputProps: { min: 0 },
                    }}
                    type="number"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Average Score"
                    name="averageScore"
                    margin="dense"
                    onChange={handleChange("averageScore")}
                    value={averageScore}
                    InputProps={{
                      inputProps: { min: 0 },
                    }}
                    type="number"
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSignOut()} color="secondary">
            Sign Out
          </Button>
          <Button
            onClick={() => handleBack()}
            disabled={currentStep === "agreements" || currentStep === "invite"}
            color="primary"
          >
            Back
          </Button>
          <Button
            onClick={() => handleSubmit()}
            color="secondary"
            disabled={getDisabled()}
          >
            {getButton()}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

NewAccountCheck.propTypes = {
  invitesReceived: PropTypes.array,
  subscriptionType: PropTypes.string,
  userData: PropTypes.object,
  subData: PropTypes.object,
  uid: PropTypes.string,
  email: PropTypes.string,
  fullName: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default NewAccountCheck;
